import { render } from "./Image1.vue?vue&type=template&id=9d061c2a"
const script = {}

import "./Image1.vue?vue&type=style&index=0&id=9d061c2a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__